import { render, staticRenderFns } from "./shopToUserSendedListDlg.vue?vue&type=template&id=6dd03d5a&scoped=true"
import script from "./shopToUserSendedListDlg.vue?vue&type=script&lang=js"
export * from "./shopToUserSendedListDlg.vue?vue&type=script&lang=js"
import style0 from "./shopToUserSendedListDlg.vue?vue&type=style&index=0&id=6dd03d5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd03d5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd03d5a')) {
      api.createRecord('6dd03d5a', component.options)
    } else {
      api.reload('6dd03d5a', component.options)
    }
    module.hot.accept("./shopToUserSendedListDlg.vue?vue&type=template&id=6dd03d5a&scoped=true", function () {
      api.rerender('6dd03d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/dialog/shopToUserSendedListDlg.vue"
export default component.exports